import Button from '@/components/base/Button';
import Reveal from '@/components/base/Reveal';

export default function ClosingSections() {
  return (
    <>
      <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-24 bg-[#1B1B1B] border-y border-white/10">
        <div className="max-w-content mx-auto">
          <Reveal className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
            <div className="max-w-2xl">
              <span className="font-label text-xs uppercase tracking-widest2 text-primary-400">
                For Suppliers
              </span>
              <h2 className="mt-4 font-heading text-2xl md:text-3xl leading-tight text-foreground-950">
                Great connections work both ways.
              </h2>
              <p className="mt-4 text-base leading-relaxed text-foreground-600">
                Are you an event professional across Greater London? We&rsquo;re building a carefully
                selected supplier network. Joining is free, with commissions agreed in advance for
                qualifying successful bookings.
              </p>
            </div>
            <div className="shrink-0">
              <Button to="/for-suppliers" variant="primary" size="lg">
                Join Our Supplier Network
              </Button>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="relative w-full overflow-hidden bg-[#090909]">
        <div className="absolute inset-0">
          <img
            src="https://storage.helloreaddy.io/project_files/70bd3036-f013-4766-9098-d293cc2afad4/c87f6168-a880-4179-9177-63769219f68b_compressed_Glamorous-Gala-Band-Performance-v2.webp"
            alt="Live band performing on stage at an elegant evening gala"
            className="w-full h-full object-cover object-top"
          />
        </div>
        {/* Centre-focused scrim — darkest behind the centred copy, fading outward */}
        <div className="absolute inset-0 hero-scrim-center" aria-hidden="true"></div>
        <div className="relative w-full px-4 md:px-8 lg:px-12 py-20 md:py-32">
          <div className="max-w-content mx-auto">
            <Reveal className="max-w-2xl mx-auto text-center flex flex-col items-center">
              <h2 className="hero-text-shadow font-heading text-2xl md:text-4xl leading-tight text-foreground-950">
                Looking for someone special for your next event?
              </h2>
              <p className="hero-text-shadow mt-5 text-base md:text-lg leading-relaxed text-foreground-900">
                Tell us what you have in mind. We&rsquo;d love to help you make the right connection.
              </p>
              <div className="mt-9">
                <Button to="/services" variant="primary" size="lg">
                  Find Your Connection
                </Button>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}